import { http } from "Utils/http";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useLocation, useNavigate } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import { Col } from "react-bootstrap";
import { TextButton } from "Components/Button";

const ListTableauUsersTable = ({ ...props}) => {
    const loginInfo = useSelector(state => state.loginInfo);
    //console.log(loginInfo);

    let location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
  

    const [sortColumn, setSortColumn] = useState({
        sortField: "userName",
        sortDirection: "asc"
    });

    const [filter, setFilter] = useState(null);
  
    useEffect(()=>{
        var passedData = location.state;
        
        if(isInObject("filter",passedData)) {
            //console.log("setFilter");
            //console.log(passedData.filter);
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex:0,
                entryPerPage:10,
                sortingColumn:sortColumn.sortField,
                sortingOrder:sortColumn.sortDirection,
                searchTerm:""
            });
        }
        //console.log(filter);
    },[])


    const getData = async (filter) => {   
        var call = filter;
        var url = '/api/manageTableau/getTableauUsers';
        
        return http.post(url, call,{
            timeout: 80000,
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const editState = function ({ rowName }) {
        return {
            userId: rowName.userId, 
            backRedirect: {
                path: location.pathname,
                state: {
                    ...location.state,
                    tab: "user"
                },
                
            }
        };
    }


    const getListCols = (selectedList, sortingInfo)=>{
        const listColumns = [];

        listColumns.push(Datatable_Column({
            name:"User Name", 
            columnName:"userName", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Organization Name", 
            columnName:'orgName',
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Last Active", 
            columnName:"lastActive", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo,
            formatFunction: formatDate
        }))
        listColumns.push(Datatable_Column({
            name:"Is Active", 
            columnName:"activeFlag", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo,
            formatFunction: (x)=> {
                if(x==1){
                    return "Yes";
                }
                else if(x==0){
                    return "No";
                }
                else {
                    return null;
                }
            }
        }))
        listColumns.push(Datatable_Column({
            name:"Match On Server", 
            columnName:"matchedOnServer", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo,
        }))
        listColumns.push(Datatable_Column({
            name:"Edit", 
            columnName:"userId", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo,
            isLink: (x) => {
                    //console.log(x);

                    var userName = x.row.userName;
                    if (userName.startsWith('TU-P')) {
                        var num = new Number(userName.substring(4));
                        if (!isNaN(num) && num >= 0 && num <= 9999) {
                            return true;
                        }
                    }
                    return false;
                    //return true;
                },
            linkData: {
                pathname: "/manage/tableau/editUser",
                text: (r) => {
                    //console.log(r);
                    var result = 'No';
                    var userName = r.row.userName;
                    if (userName.startsWith('TU-P')) {
                        var num = new Number(userName.substring(4));
                        if (!isNaN(num) && num >= 0 && num <= 9999) {
                            result = 'Edit';  
                        }
                    }
                    return result;
                }, 
                state: editState
            },
            formatFunction: (x)=> {
                //console.log(x);
                return "No";
            }
        }))
        
        return listColumns;
      }

      const tableTitle = function () {
        return "Interactive Report Users";
      }
      
      const tableDescription = function() {
        return null;
      }
      const [selectedCount, setSelectedCount] = useState(0);

      const handleCreateUser = ()=> {
            navigate(
                "/manage/tableau/createUser",
                { 
                    state: {
                        backRedirect: {
                            path: location.pathname,
                            state: {...location.state, tab: "user"}
                        }
                }}
            );
      }

    return (
        <>
        
            {   
                filter!=null 
                ?
                    <DatatableBase 
                        tableClassName="tableauReportUsersTable" 
                        uniqueId="tableauReportUsersTable" 
                        filter = {filter}
                        setFilter={setFilter}
                        getData={getData} 

                        getListCols={getListCols} 
                        setSelectedCount={setSelectedCount} 
                        hasSelectableRows={false} 
                        
                        datatableHeader={tableTitle()} 
                        datatableDescription={tableDescription()}
                        searchFieldText={"Search by User Name, Organizatin Name"} 

                        sortingColumn={sortColumn.sortField} 
                        sortingOrder={sortColumn.sortDirection}
                    >
                        {
                            <Col className="d-flex justify-content-end gap-4">
                                {
                                    <>
                                        <TextButton className="" title="Click on this button to Create a New Tableau User"  onClick={handleCreateUser} variant="normal" content={"Add New User"}/>
                                    </>
                                }
                            </Col>
                        }
                    </DatatableBase>
                :   null
            }  
        </>
    );
}

export default ListTableauUsersTable;